import ExcelJS from "exceljs";

export const exportToExcelSingleSheet = async (
  data,
  fileName = "data.xlsx",
  headerText = null,
) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("إيرادات");

  let currentRow = 3;

  // A function to add data to the paper
  const addSection = (title, headers, records) => {
    // Add the department address
    worksheet.mergeCells(currentRow, 1, currentRow, headers?.length || 4);
    worksheet.getCell(currentRow, 1).value = title;
    worksheet.getCell(currentRow, 1).alignment = { horizontal: "center" };
    currentRow++;

    // Add addresses
    worksheet.addRow(headers).font = { bold: false };
    currentRow++;

    // Add data
    records?.forEach((record) => {
      worksheet.addRow(record);
      currentRow++;
    });

    // Add an empty line
    currentRow++;
  };

  // 1.Total revenue
  addSection(
    "الإيرادات الإجمالية",
    ["الدفع بالبطاقة", "التحويل البنكي", "الاستقطاع", "الإجمالي"],
    [
      [
        data.totalRevenue.cardPayment,
        data.totalRevenue.bankTransfer,
        data.totalRevenue.recurringPayment,
        data.totalRevenue.total,
      ],
    ],
  );

  // 2. Project revenue
  addSection(
    "إيرادات المشاريع",
    ["عنوان المشروع", "الدفع بالبطاقة", "التحويل البنكي", "الإجمالي"],
    data.projectRevenues.map((item) => [
      item.projectTitle,
      item.cardPayment,
      item.bankTransfer,
      item.total,
    ]),
  );

  // 3. Fast donation revenues
  addSection(
    "إيرادات التبرعات السريعة",
    ["تصنيف المشروع", "الدفع بالبطاقة", "التحويل البنكي", "الإجمالي"],
    data.fastDonationRevenues.map((item) => [
      item.classificationTitle,
      item.cardPayment,
      item.bankTransfer,
      item.total,
    ]),
  );

  // 4.Project gift revenues
  addSection(
    "إيرادات هدية المشروع",
    ["عنوان المشروع", "الدفع بالبطاقة", "التحويل البنكي", "الإجمالي"],
    data.giftProjectRevenues.map((item) => [
      item.giftProjectTitle,
      item.cardPayment,
      item.bankTransfer,
      item.total,
    ]),
  );

  // 5. recurring Payments
  addSection(
    "الدفعات المتكررة",
    ["عنوان المشروع", "المبلغ المدفوع"],
    data.recurringPayments.map((item) => [item.projectTitle, item.payment]),
  );

  if (headerText) {
    worksheet.mergeCells(1, 1, 1, 4); // Merging the first row
    const mergedCell = worksheet.getCell(1, 1); // Get the compact cell
    mergedCell.value = headerText; // تعيين النص
    mergedCell.alignment = { horizontal: "center", vertical: "middle" }; //Alignment of the text
    worksheet.getRow(1).height = 30;
  }

  // Adjust the columns width
  worksheet.columns.forEach((column) => {
    column.width = column.header ? column.header.length + 25 : 25;
  });

  //Export the file
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: "application/octet-stream" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
